var twig = require("twig").twig,
    template = twig({"id":"10fa688df208b7e8bab3958c0429ed1f57fe353c0215a806b371343bb90ad372a574f6ace3959a195845aacc2b72485a3f7127dbc35f1d815fa94b7679c16389","data":[{"type":"raw","value":"<div class=\"grid\"></div>\n"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }